import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"map-blocked"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M18 21.5C20.4853 21.5 22.5 19.4853 22.5 17C22.5 14.5147 20.4853 12.5 18 12.5C15.5147 12.5 13.5 14.5147 13.5 17C13.5 19.4853 15.5147 21.5 18 21.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 6.5L9 3L3 6.5V20L9 17.5M15 6.5L21 4V9.5M15 6.5V9.5M9 17.5V3.5M9 17.5L10.5 18.375","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M20.4749 14.5251L15.5251 19.4749M21.182 20.182C19.4246 21.9393 16.5754 21.9393 14.818 20.182C13.0607 18.4246 13.0607 15.5754 14.818 13.818C16.5754 12.0607 19.4246 12.0607 21.182 13.818C22.9393 15.5754 22.9393 18.4246 21.182 20.182Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MapBlocked = Vue.extend<IconProps>({
  name: 'MapBlockedIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'map-blocked',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MapBlocked;
